import React from 'react';
import cx from 'classnames';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const FormRow = ({
  children,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.row, className), style }, children);
FormRow.displayName = "Forms.WalletForm.FormRow";
const BottomGroup = ({
  children,
  onlyMobile,
  className,
  style
}) => {
  const { windowSize } = useWindowSize();
  if (onlyMobile && windowSize.width < 1025 || !onlyMobile) {
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles["bottom-group"], className), style }, children);
  }
  return children;
};
BottomGroup.displayName = "Forms.WalletForm.BottomGroup";
const FormText = ({
  boldColor = "inherit",
  noMargin = false,
  textCenter = false,
  children,
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.text, className, {
      [styles["no-margin"]]: noMargin,
      [styles["text-center"]]: textCenter
    }),
    style: {
      ...style,
      "--bold-color": boldColor
    }
  },
  children
);
FormText.displayName = "Forms.WalletForm.FormText";
const FormIcon = ({
  hasValue,
  children,
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.icon, className, {
      [styles.value]: hasValue
    }),
    style
  },
  children
);
FormIcon.displayName = "Forms.WalletForm.FormIcon";
const Wrapper = ({
  title,
  children,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), /* @__PURE__ */ React.createElement("div", { className: styles.body }, children));
Wrapper.displayName = "Forms.WalletForm.Wrapper";

export { BottomGroup, FormIcon, FormRow, FormText, Wrapper };
//# sourceMappingURL=index.js.map
